<template>
  <div
    class="search-location-header mt4"
    :class="[
      clientPlatform == 'Web' ? 'dt-mw-434' : '',
      isAutocompletePredictionVisible ? '' : 'mb10',
    ]"
  >
    <div
      :class="[clientPlatform == 'Web' ? 'ete-wrap' : '']"
      class="full-width pl16 pr16"
    >
      <div :class="[clientPlatform == 'Web' ? 'container-desktop' : '']">
        <div class="search-location-bar full-width">
          <i
            class="hkfi-back fs-16 bold color-slaty-dark"
            @click="handleBackButtonClick"
          ></i>
          <input
            @input="triggerSearchLocation($event)"
            class="search-location-input"
            id="searchLocationInput"
            type="text"
            name="searchLocationInput"
            ref="searchLocationInput"
            :placeholder="searchPlaceholderText"
            v-model="searchLocationText"
          />
          <img
            @click="resetSearchBar($event)"
            class="color-black fs-xlg"
            v-if="showCancelButton"
            :src="staticImgBaseUrl + '/images/global/clear-icon.svg'"
            alt="location-pin"
          />
          <i v-else class="hkfi-search-lens medium fs-24 color-slaty-dark" />
          <!-- <i
            v-if="showCancelButton"
            class="hkfi-close fs-16 color-slaty-dark"
            @click="resetSearchBar($event)"
          /> -->
        </div>
      </div>
    </div>

    <div
      class="use-current-location"
      v-if="!isAutocompletePredictionVisible && currentGPSLocation"
      @click="getCurrentLocation($event)"
    >
      <div class="disp-col-inline">
        <img
          :src="staticImgBaseUrl + '/images/global/current-location-icon.svg'"
          alt="location-pin"
        />
        <span class="ml10 fs-14">{{
          modulePropsData?.useCurrentLocationTitle
        }}</span>
      </div>
      <i v-if="isLocationLoading" class="loader-round fs-12" />
      <i v-else class="hkfi-arrow-line fs-12"></i>
    </div>
    <div
      class="use-current-location"
      v-else-if="!isAutocompletePredictionVisible && !currentGPSLocation"
    >
      <div class="disp-col-inline">
        <img
          :src="staticImgBaseUrl + '/images/global/current-location-icon.svg'"
          alt="location-pin"
        />
        <span class="ml10 fs-12">{{ modulePropsData?.giveLocationTitle }}</span>
      </div>
      <button
        class="line-btn extra-sm pr8 pl8"
        @click="getCurrentLocation($event)"
      >
        {{ modulePropsData?.allowCtaText }}
      </button>
    </div>

    <location-not-found v-if="noInternet"></location-not-found>
  </div>
</template>

<script>
import Utility from "../helpers/utility";
import { keyMapsAction, keyMapsMutation } from "../helpers/storeKeys";
import { staticImgBaseUrl, clientPlatform } from "../config/apiEndpoints";
import {
  EVENT_LOCATION_CLICK,
  EVENT_LOCATION_ADDRESS_INPUT,
} from "../helpers/analyticsEvents";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { LocationPageStaticKeys } from "../helpers/addressConstants";

export default {
  name: "SearchLocationHeader",
  components: {
    //
  },
  props: ["modulePropsData"],
  data() {
    return {
      searchLocationText: "",
      searchTriggered: false,
      clientPlatform,
      staticImgBaseUrl,
      LocationPageStaticKeys,
    };
  },
  mounted() {
    this.focusSearchInput();
    this.resetSearchBar();
  },
  methods: {
    focusSearchInput() {
      this.$refs.searchLocationInput?.focus();
    },
    resetSearchBar(e) {
      this.searchLocationText = "";
      this.$store.commit(keyMapsMutation.CLEAR_AUTOCOMPLETE_INPUT);
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_LOCATION_LOADING, false);
    },
    getCurrentLocation(e) {
      let currentGPSLocation =
        LocalStorageFunc.getCurrentGPSLocation()?.geometry?.location;
      if (!currentGPSLocation) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
          true
        );
      } else {
        this.$store.commit(keyMapsMutation.UPDATE_SHOW_LOCATION_LOADING, true);
        this.$store.dispatch(keyMapsAction.DETECT_CURRENT_LOCATION, {
          showDeliveryMapScreen: true,
          currentLocationDisplay: true,
        });
      }
    },
    triggerSearchLocation(e) {
      if (e.target.value.length > 2) {
        this.$store.dispatch(keyMapsAction.AUTOCOMPLETE_LOCATION_API, {
          input: e.target.value,
        });
        if (!this.searchTriggered) {
          EVENT_LOCATION_CLICK({
            sectionName: "search",
            sectionPosition: 1,
            position_within_section: 2,
            category: "opened",
            subcategory: e.target.value,
          });
          this.searchTriggered = true;
        }
      } else if (e.target.value.length === 0) {
        this.$store.commit(keyMapsMutation.CLEAR_AUTOCOMPLETE_INPUT);
        this.searchTriggered = false;
      } else if (e.target.value.length === 1) {
        EVENT_LOCATION_ADDRESS_INPUT({
          userAction: "adress input flow begin",
          sectionName: "change location",
          sectionPosition: 1,
          positionWithinSection: 2,
          category: "manual input",
        });
      }
    },
    handleBackButtonClick(e) {
      Utility.appBackButtonFunc();
      if (this.$store.state.Location.autoCompleteInvalidInput) {
        this.resetSearchBar(e);
      } else {
        LocalStorageFunc.setSelectedChangedLocationForTwyDinein({});
        Utility.redirectToHomeOrRedirectUrl([
          { name: "changeTriggerFromDineinTwy", value: false },
        ]);
      }
    },
  },
  computed: {
    showCancelButton() {
      return this.searchLocationText.length > 0;
    },
    triggerAddEditAddress() {
      return (
        this.$store.state.User.showAddAddressLocationScreen ||
        this.$store.state.User.showEditAddressLocationScreen
      );
    },
    isLocationLoading() {
      return this.$store.state.Location.showLocationLoading;
    },
    noInternet() {
      return this.$store.state.Location.noInternet;
    },
    isAutocompletePredictionVisible() {
      return this.$store.state.Location.autoCompletePredictions.length > 0;
    },
    currentGPSLocation() {
      return LocalStorageFunc.getCurrentGPSLocation()?.geometry?.location;
    },
    searchPlaceholderText() {
      return (
        this.modulePropsData?.searchText ||
        this.LocationPageStaticKeys?.searchText
      );
    },
  },
};
</script>
